import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.messages.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default", { messages: _ctx.messages }, () => [
          _createVNode(_TransitionGroup, {
            name: "o-anim-fade-300",
            class: "list-reset text-roman",
            tag: "ul"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (message, ix) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: message+ix
                }, _toDisplayString(message.labelKey ? _ctx.$dictionary.get(message.labelKey) : message.message || message.value || _ctx.$dictionary.get('global/generic/unexpectedServerError')), 1))
              }), 128))
            ]),
            _: 1
          })
        ])
      ]))
    : _createCommentVNode("", true)
}